import { useEffect, useState } from "react";

export const formOptionsLoader = <TItem, TResponse extends { items: TItem[] }>(
    fetchFunction: () => Promise<TResponse>,
    setAreOptionsLoading: (areLoading: boolean) => void,
    setOptions: (options: TItem[]) => void
): void => {
    setAreOptionsLoading(true);
    fetchFunction()
        .then((res) => setOptions(res.items))
        .finally(() => setAreOptionsLoading(false));
};

export const useAreOptionsLoading = (areOptionsLoadingFlags: boolean[]): { areOptionsLoading: boolean } => {
    const [areOptionsLoading, setAreOptionsLoading] = useState(false);

    useEffect(() => {
        setAreOptionsLoading(areOptionsLoadingFlags.some((isLoading) => !!isLoading));
    }, areOptionsLoadingFlags);

    return {
        areOptionsLoading
    };
};
